import Relationships from "./relationship/index.js";
import Routes from "./route/index.js";
import Reducers from "./reducer/index.js";
import Attributes from "./attributes/index.js";
import Blockers from "./blockers/index.js";
import Analyzers from "./analyzer/index.js";
import DataSources from "./dataSource/index.js";
import Actions from "./actions/index.js";
import Views from "./views/index.js";
import ItemActionHooks from "./itemActionHook/index.js";
export default {
  init: async molten => {
    Relationships.install(molten);
    Routes.install(molten);
    Reducers.install(molten);
    Attributes.install(molten);
    Blockers.install(molten);
    Analyzers.install(molten);
    DataSources.install(molten);
    Actions.install(molten);
    Views.install(molten);
    ItemActionHooks.install(molten);
  },
  sort: 10,
  id: 'leverege.fotaApi.pluginInitializer'
};